// extracted by mini-css-extract-plugin
export var quantityInput = "_ez-0";